<template>
    <section class="student-add-course-view">
        <h3>Add Course To Student</h3>
        <label>
            <span class="visuallyhidden">Title or CRN</span>
            <app-input 
                v-model="query" 
                placeholder="Title or CRN"
                autofocus/>
        </label>
        <div class="classes">
            <course-table
                :items="courses"
                :columns="['title','time','location']"
                :allow-sort="false"
                :handle-click="handleAddCourse"
                :empty-add="true"/>
        </div>
    </section>
</template>
<script>
import CourseTable from '../Course/CourseTable'
import Course from '@/store/models/Course'

export default {
    name: 'student-add-course-view',
    inject: ['modalOptions'],
    components: {
        CourseTable
    },
    props: ['student'],
    data() {
        return {
            courses: [],
            query: ''
        }
    },
    methods: {
        getCourseList(query) {
            this.loading = true
            Course.$search({
                query: query,
                scoped: false
            }).then(courses => {
                this.loading = false
                this.courses = courses
            })
        },

        handleAddCourse(course) {
            this.student.$attach(course.id, 'courses', 'addCourseToStudent')
                .then(() => {
                    this.modalOptions.modalOpen = false
                })

            return false
        }
    },
    watch: {
        query(newValue) {
            this.getCourseList(newValue)
        }
    }
}
</script>

<style lang="stylus"></style>
